export const connect_source = (node) => {
    return {
        type:'CONNECT_EDGE',
        open:true,
        source:node
    }
}

export const connect_target = (node) => {
    return {
        type:'CONNECT_TARGET',
        open:false,
        target:node
    }
}

export const connect_abort = () => {return {type:'CONNECT_ABORT'}}

export const open_login_dialog = () => {return {type:'OPEN_LOGIN_DIALOG'}}

export const open_snackbar_dialog = (msg, duration) => {return {type:'OPEN_SNACKBAR_DIALOG', message:msg, duration:duration}}

export const close_snackbar_dialog = () => {return {type:'CLOSE_SNACKBAR_DIALOG'}}

export const open_create_node = (connect_type, target, position) => {
    return {
        type: 'OPEN_CREATE_NODE',
        connect_type: connect_type,
        target,
        position:position
    }
}

export const open_edit_node = (target, position) => {
    return {
        type: 'OPEN_EDIT_NODE',
        target,
        position:position
    }
}

export const open_create_group = (target, position) => {
    return {
        type: 'OPEN_CREATE_GROUP',
        target,
        position:position
    }
}

// [#136] 그룹(부모) 노드를 삭제할 때 "그룹만 삭제"할지 "그룹+안의 지식을 모두 삭제"할지 선택하는 다이얼로그
export const open_delete_group = (target) => {
    return {
        type: 'OPEN_DELETE_GROUP',
        target
    }
}

export const close_delete_group = () => {
    return {type: 'CLOSE_DELETE_GROUP'}
}

export const group_add_open = (group) => {
    return {type: 'GROUP_ADD_OPEN', group}
}

export const group_add_close = () => {
    return {type: 'GROUP_ADD_CLOSE'}
}

// [#133 재설계] 빈 공간에서 그룹 생성: 이름 입력 후 곧바로 노드를 만들지 않고,
// 포함될 지식을 먼저 고르게 한 뒤 "선택완료" 시점에 한 번에 그룹 노드를 생성한다.
export const open_group_member_select = (label, position) => {
    return {type: 'OPEN_GROUP_MEMBER_SELECT', label, position}
}

export const toggle_group_member_select = (node_id) => {
    return {type: 'TOGGLE_GROUP_MEMBER_SELECT', node_id}
}

export const close_group_member_select = () => {
    return {type: 'CLOSE_GROUP_MEMBER_SELECT'}
}

// [#138] 노드 드래그 종료 후, 놓인 위치가 소속되지 않은 그룹의 bounding box 안이라면
// 그룹 편입 여부를 확인하는 다이얼로그를 연다.
export const open_group_join_confirm = (node_id, group_id, group_label) => {
    return {type: 'OPEN_GROUP_JOIN_CONFIRM', node_id, group_id, group_label}
}

export const close_group_join_confirm = () => {
    return {type: 'CLOSE_GROUP_JOIN_CONFIRM'}
}

export const select = (id, is_need_animation=false) => {
    return {
        type:'SELECT_NODE',
        selected_node:{
            id:id,
            is_need_animation:is_need_animation
        }
    }
};

export const close_tooltip = () => {
    return {type:'CLOSE_TOOLTIP'}
}

export const open_tooltip = (id, url, label, pos, countMarking) =>{
    return {type:'OPEN_TOOLTIP', id, url, label, pos, countMarking};
}

export const up_saw = (id) => {
    return {type:'UP_SAW', id}
}

export const set_user_marking = (marked) => {
    return {type:'SET_USER_MARKING', marked:marked}
}